import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserManagementService } from 'src/app/services/user-management.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HeaderBarAction } from 'src/app/components/header-bar/header-bar.component';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { ChangePasswordDialogComponent } from 'src/app/dialogs/change-password-dialog/change-password-dialog.component';
import { User } from 'src/app/models/user';
import { LoggedUser, UserProfile } from 'src/app/models/logged-user';
import { AddUserDialogComponent } from 'src/app/dialogs/add-user-dialog/add-user-dialog.component';

@Component({
    selector: 'app-main-page',
    templateUrl: './main-page.component.html',
    styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit {
    loggedUser: LoggedUser;
    showAdminCatalog: Boolean;
    showAdminUser: Boolean;
    showChangePassword: Boolean;
    showAddUser: Boolean;
    showLogout: Boolean;

    constructor(private router: Router,
        private userManagementService: UserManagementService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar) { }

    ngOnInit() {
        this.loggedUser = this.userManagementService.getLoggedUser();

        this.showAdminCatalog = this.loggedUser.profile == UserProfile.Admin;
        this.showAdminUser = this.loggedUser.profile == UserProfile.Admin;
        this.showAddUser = this.loggedUser.profile == UserProfile.Admin;

        if (this.loggedUser.profile == UserProfile.Admin)
            this.router.navigate(['main/users']);
        else
            this.router.navigate(['main/warehouse']);
    }

    async onHeaderBarAction(action: HeaderBarAction) {
        switch (action) {
            case HeaderBarAction.AdminCatalog: {
                this.router.navigate(['main/warehouse']);
                break;
            }

            case HeaderBarAction.AdminUsers: {
                this.router.navigate(['main/users']);
                break;
            }

            case HeaderBarAction.Billboard: {
                this.router.navigate(['main/billboard']);
                break;
            }

            case HeaderBarAction.AddUser: {
                await this.DoAddUser();
                break;
            }

            case HeaderBarAction.ChangePassword: {
                await this.DoChangePassword();
                break;
            }

            case HeaderBarAction.Logout: {
                await this.DoLogout();
                break;
            }
        }

    }

    private async RefreshUserList() {
        // this.userList = await this.userManagementService.userList();
    }

    private async DoAddUser() {
        let res = await this.dialog.open(AddUserDialogComponent, {
            width: '400px',
            panelClass: 'custom-dialog-container'
        }).afterClosed().toPromise();
        if (res) {
            await this.RefreshUserList();
        }
    }

    private async DoLogout() {
        let reply = await this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            panelClass: 'custom-dialog-container',
            data: new ConfirmDialogData('Logout', 'Are you sure ?', 'YES', 'NO')
        }).afterClosed().toPromise();
        if (reply) {
            this.userManagementService.logout();
            this.router.navigate(['user/login']);
        }
    }

    private async DoChangePassword() {
        await this.dialog.open(ChangePasswordDialogComponent, {
            width: '400px',
            panelClass: 'custom-dialog-container'
        }).afterClosed().toPromise();
    }

}
